// extracted by mini-css-extract-plugin
module.exports = {"root":"rdg_19420c53"};